import React, { Suspense, useEffect } from "react";
// routing
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// redux
import { useDispatch, useSelector } from "react-redux";
// types
import { SET_ADMIN } from "./store/admin/types";

// pages
import Admin from "./pages/Admin";
import HostHistory from "./pages/HostHistory";
import HostHistoryInfo from "./pages/HostHistoryInfo";
import LanguageSwitcher from "./components/languageSwitcher/LanguageSwitcher";
import i18n from "./i18n";

function App() {
  const dispatch = useDispatch();
  const { isAuth } = useSelector((state) => state.admin);
  const token = localStorage.getItem("TOKEN");
  const key = localStorage.getItem("KEY");

  const params = new URLSearchParams(window.location.search);
  
  const hostId = params.get("id") || localStorage.getItem("hostId");

  const language = params.get("language") || localStorage.getItem("language");

  localStorage.setItem("hostId", hostId);

  if (language && ["en", "ja"].includes(language.toLowerCase())) {
    const normalizedLang = language.toLowerCase();
    localStorage.setItem("language", normalizedLang);
    i18n.changeLanguage(normalizedLang);
  }

  useEffect(() => {
    if (!token && !key) return;
    dispatch({ type: SET_ADMIN, payload: token });
  }, [token, key, dispatch]);

  return (
    <div className="App">
    <LanguageSwitcher />
      <Suspense fallback={""}>
        <BrowserRouter>
          <Routes>
            {/* Define routes using `element` */}
            <Route path="/host/homePage" element={<Admin />} />
            <Route path="/host/hosthistory" element={<HostHistory />} />
            <Route path="/host/historyInfo" element={<HostHistoryInfo />} />

            {/* Redirect from `/` to `/host/homePage` */}
            <Route path="/" element={<Navigate to="/host/homePage" replace />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default App;
